import React from 'react'
import ProductsContainer from './ProductsContainer'
import CartContainer from './CartContainer'

const ShopContainer = () => (
  <div>
    <ProductsContainer />
    <CartContainer />
  </div>
)

export default ShopContainer



// WEBPACK FOOTER //
// ./src/Shop/containers/ShopContainer.js